import styled from 'styled-components';
import { primary } from '../themes/colors';

export const FeatureInfoWrapper = styled.div<{
  $textAlign?: 'left' | 'center' | 'right';
}>`
	font-family: ${props => props.theme.font};
  text-align: ${({ $textAlign }) => $textAlign || 'center'};
`;  

export const FeatureInfoContent = styled.div`
	display: flex;
	flex-direction: column;
	gap: 10px;
  p {
    margin: 0;
  }
`;

export const FeatureInfoHeading = styled.h3`
  color: ${primary['400']};
`;
